<template>
    <form-row title="Will an inspection be performed for this transaction?">
        <div class="flex flex-1 items-center">
            <input-radio-boolean
                name="has_inspection"
                v-model="has_inspection"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        has_inspection: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },

}
</script>
